import { Link } from "react-router-dom";

export const LegalLayout = ({ title, effectiveDate, children }) => (
  <div className="min-h-screen bg-sand flex flex-col">
    <header className="border-b border-bone bg-sand/90 backdrop-blur-md sticky top-0 z-40">
      <div className="max-w-4xl mx-auto px-6 md:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="legal-logo" className="font-serif text-2xl font-semibold text-ink">
          KIS Living<span className="text-terracotta">.</span>
        </Link>
        <Link to="/" data-testid="legal-back-home" className="text-sm font-medium text-ink-soft hover:text-terracotta transition-colors">
          ← Back to home
        </Link>
      </div>
    </header>

    <main className="flex-1">
      <div className="max-w-4xl mx-auto px-6 md:px-8 py-14 md:py-20">
        <h1 className="font-serif text-4xl sm:text-5xl font-semibold text-ink">{title}</h1>
        {effectiveDate && <p className="text-ink-soft text-sm mt-3">Effective Date: {effectiveDate}</p>}
        <div className="legal-content mt-10 space-y-6 text-ink-soft leading-relaxed">
          {children}
        </div>
      </div>
    </main>

    <footer className="bg-ink text-white/70">
      <div className="max-w-4xl mx-auto px-6 md:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
        <p className="font-serif text-lg text-white">KIS Living<span className="text-terracotta">.</span></p>
        <div className="flex gap-5">
          <Link to="/" className="hover:text-terracotta transition-colors">Home</Link>
          <Link to="/terms" className="hover:text-terracotta transition-colors">Terms of Service</Link>
          <Link to="/privacy" className="hover:text-terracotta transition-colors">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  </div>
);

export const H2 = ({ children }) => (
  <h2 className="font-serif text-2xl sm:text-3xl font-semibold text-ink pt-4">{children}</h2>
);
export const H3 = ({ children }) => (
  <h3 className="font-serif text-xl font-semibold text-ink pt-2">{children}</h3>
);
export const P = ({ children }) => <p className="text-base">{children}</p>;
export const LI = ({ children }) => (
  <li className="text-base ml-5 list-disc marker:text-terracotta">{children}</li>
);
